import { AbstractControl } from '@angular/forms';
import {
  MonoTypeOperatorFunction,
  filter,
  map,
  merge,
  tap,
  withLatestFrom,
} from 'rxjs';

/**
 * @param control Control for which the default value should be managed
 *
 * @returns
 * Operator that uses the latest emitted value to manage the default value
 * of the given control.
 * It also tries to manage the pristine state of the control and listen
 * to the form being reset.
 */
export function useLatestAsDefaultValue<T>(
  control: AbstractControl,
): MonoTypeOperatorFunction<T> {
  // TODO: Find a more general way to handle dynamic default values
  // Preserves the last emitted value when a form is reset and
  // restores the forms / controls pristine state on page reloads
  return (obs$) =>
    merge(
      obs$.pipe(
        tap((value) => {
          if (value === control.value && control.untouched) {
            control.markAsPristine();
          }
        }),
        filter(() => !control.dirty),
      ),
      control.valueChanges.pipe(
        filter(() => !control.dirty),
        withLatestFrom(obs$),
        filter(([value, latestValue]) => value !== latestValue),
        map(([value, latestValue]) => latestValue),
      ),
    );
}
